import PropTypes from 'prop-types';
import React from 'react';
import { Row, Col, Button, Spinner } from 'reactstrap';
import Icon from '../../../common/containers/icon';
const HeaderSection = ({
  summary: _summary = {},
  isRunning: _isRunning = false,
  pendingOperation: _pendingOperation = false,
  onReRun,
  onOpenSettings,
  formatTimestamp
}) => /*#__PURE__*/React.createElement(Row, {
  className: "mb-4 align-items-center"
}, /*#__PURE__*/React.createElement(Col, {
  lg: 8
}, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
  className: "mb-0"
}, "Traceable. Reliable. Understandable."), /*#__PURE__*/React.createElement("div", {
  className: "text-muted"
}, _summary.timestamp && `Last Run: ${formatTimestamp(_summary.timestamp)}`))), /*#__PURE__*/React.createElement(Col, {
  lg: 4
}, /*#__PURE__*/React.createElement("div", {
  className: "quality-agent__header-actions"
}, /*#__PURE__*/React.createElement(Button, {
  color: "primary",
  outline: true,
  onClick: onReRun,
  disabled: _isRunning || _pendingOperation,
  className: "quality-agent__action-button"
}, _isRunning ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spinner, {
  size: "sm",
  className: "me-2"
}), "Running...") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
  glyph: "rotate-right",
  className: "quality-agent__icon-spacing"
}), "Re-Run")), /*#__PURE__*/React.createElement(Button, {
  color: "secondary",
  outline: true,
  onClick: onOpenSettings,
  className: "quality-agent__action-button"
}, /*#__PURE__*/React.createElement(Icon, {
  glyph: "gear",
  className: "quality-agent__icon-spacing"
}), "Settings"))));
HeaderSection.propTypes = {
  summary: PropTypes.shape({
    timestamp: PropTypes.string
  }),
  isRunning: PropTypes.bool,
  pendingOperation: PropTypes.bool,
  onReRun: PropTypes.func.isRequired,
  onOpenSettings: PropTypes.func.isRequired,
  formatTimestamp: PropTypes.func.isRequired
};
export default HeaderSection;